import { ChevronDown } from "lucide-react";
import React from "react";

export const ChannelSelect: React.FC<{
  value: string; 
  onChange: (v: string) => void;
  options: { label: string; value: string; icon: React.ReactNode }[];
  disabled?: boolean; // Add disabled prop
}> = ({ value, onChange, options, disabled = false }) => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const selected = options.find((o) => o.value === value) ?? options[0];

  React.useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button" 
        onClick={() => !disabled && setOpen((p) => !p)}
        className={`w-full flex items-center gap-2 border border-gray-200 dark:border-white rounded-lg px-3 py-2.5 text-sm text-gray-800 dark:text-white bg-white dark:bg-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors ${
          disabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-gray-800' : 'hover:bg-gray-50 dark:hover:bg-gray-800'
        }`}
        disabled={disabled}
      >
        <span className="flex-shrink-0">{selected.icon}</span>
        <span className="flex-1 text-left">{selected.label}</span>
        <ChevronDown size={16} className="text-[#7B7B7B] font-semibold dark:text-gray-500 flex-shrink-0" />
      </button>
      {open && !disabled && (
        <div className="absolute top-full left-0 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 overflow-hidden">
          {options.map((o) => (
            <button
              key={o.value} type="button"
              onClick={() => { onChange(o.value); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${o.value === value ? 'bg-indigo-50 dark:bg-indigo-500/15 text-indigo-700 dark:text-indigo-400' : 'text-gray-800 dark:text-gray-200'}`}
            >
              <span className="flex-shrink-0">{o.icon}</span>
              <span>{o.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};